var DownloadOption;
(function (DownloadOption) {
    DownloadOption["DOWNLOAD"] = "download";
    DownloadOption["OPEN"] = "open";
})(DownloadOption || (DownloadOption = {}));

export { DownloadOption };
